<style src="./DebitHistory.scss" lang="scss"></style>
<template>
  <section class="DebitHistory">
    <div class="ibox">
      <div class="ibox-content">

        <h2 class="title is-4" title="Historico detalhado da compra de crédito para a carteira">Histórico de Débitos</h2>
        
        
        <div class="table-responsive content">
          <Spinner v-if="isLoading" />
          <div class="text-center" v-if="!isLoading && list.length === 0">
            <h3>Nenhum registro encontrado!</h3>
            <div class="error-desc">
              Não foram encontrados nenhuma compra de crédito para a carteira deste cliente.
            </div>
          </div>

          <table class="table table-striped table-hover" v-if="!isLoading && list.length > 0">
            <thead>
              <tr>
                <!-- <th></th> -->
                <th>Data</th>
                <th>Hora</th>
                <th>Placa</th>
                <th>Tempo(min)</th>
                <th>Local</th>
                <th class="balance">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in list" :key="index">
                  <!-- <td class="client-avatar"><img alt="image" src="img/a2.jpg"> </td> -->
                  <td class="date">{{ formatDate(item.paymentDate) }}</td>
                  <td class="hours">{{ formatTime(item.paymentDate) }}</td>
                  <td class="client-status licencePlate"><span class="label label-primary">{{ item.vehicle }}</span></td>
                  <td class="minutes"><small>{{ item.totalMinutes }}</small></td>
                  <td class="client-status place"><span class="placetext">{{ item.parking }}</span></td>
                  <td class="text-success balance"><small>R$</small> {{ formatCurrency(item.amountPaid) }}</td>
              </tr>
            </tbody>
          </table>
          <div>
            <table class="table invoice-total">
              <tbody>
                <tr>
                  <td><strong>Total :</strong></td>
                  <td class="text-success balance">R$ {{ formatCurrency(totalAmount) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="text-right">
          <div class="btn-group">
            <button class="btn btn-white" type="button" :disabled="previousButtonDisabled" @click="previousPage">
              <i class="fa fa-chevron-left"></i>
            </button>
            <button class="btn btn-white" type="button" :disabled="nextButtonDisabled" @click="nextPage">
              <i class="fa fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Spinner from '@/components/Spinner';
export default {
  components: {
    // Statement,
    Spinner,
  },
  data() {
    return {
      isLoading: false,
      list: [],
      totalAmount: 0,
      countTotal: 0,
      pageSkip: 0,
      pageLimit: 6,
      isModalVisible: false,
      details: {
        dateCreated: '',
        datePayment: '',
        transactionId: '',
        amountPaid: 0,
        method: '',
        paid: false,
        movementType: ''
      }
    }
  },
  mounted() {
    this.loadInfo();
  },
  computed: {
    previousButtonDisabled() {
      return this.pageSkip === 0;
    },
    nextButtonDisabled() {
      return this.pageSkip + this.pageLimit >= this.countTotal;
    }
  },
  methods: {
    formatDate(value) {
      if (!value) return ''
      const date = new Intl.DateTimeFormat('pt-BR', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      }).format(new Date(value));

      return date;
    },
    formatTime(value) {
      if (!value) return ''
      const time = new Intl.DateTimeFormat('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
      }).format(new Date(value));

      return time;
    },
    formatCurrency(value) {
      if (!value) {
        return '0,00';
      }
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    paidStatus(value) {
      if (value) {
        return 'Pago';
      }
      return 'Pendente';
    },
    async loadInfo() {
      try {
        this.isLoading = true;
        
        const payload = {
          pageSkip: this.pageSkip,
          pageLimit: this.pageLimit,
          user: this.$route.params.userToken,
        };
        const buyHistory = await this.$store.dispatch(
          'CONSUMER/DebitHistory',
          payload,
        );

        this.list = buyHistory.history;
        this.countTotal = buyHistory.countTotal;
        this.totalAmount = buyHistory.totalAmountPaid;
      } catch(error) {
        console.error('Error loading consumer info:', error);
      } finally {
        this.isLoading = false;
      }
    },
    nextPage() {
      this.pageSkip += this.pageLimit;
      this.loadInfo();
    },
    previousPage() {
      this.pageSkip -= this.pageLimit;
      this.loadInfo();
    },
    showDetails(item) {
      this.details.dateCreated = item.dateCreated;
      this.details.datePayment = item.paymentDate;
      this.details.transactionId = item.transactionId;
      this.details.amountPaid = item.amountPaid;
      this.details.method = item.method;
      this.details.paid = item.paid;
      this.details.status = item.status;

      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    methodStyle(method) {
      switch (method) {
        case 'PIX':
          return 'label-success';
        case 'Cartão':
          return 'label-warning';
        case 'Bônus':
          return 'label-info';
        default:
          return '';
      }
    },
    paidStyle(paid) {
      if (paid) {
        return 'label-primary';
      }
      return 'label-danger';
    } 
  }
};
</script>
